import { Button } from '@shared/components/ui/button';
import { faFileArrowDown, faSpinnerThird } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import type { LegacyDashboardClient } from '../../models/LegacyDashboardClient';
import { useExportLegacyDashboard } from '../../hooks/useExportLegacyDashboard';

interface DownloadExcelButtonProps {
  clients: LegacyDashboardClient[];
}

export const DownloadExcelButton = ({ clients }: DownloadExcelButtonProps) => {
  const { t } = useTranslation('legacyDashboardModule');
  const { exportLegacyDashboard, isExporting } = useExportLegacyDashboard();

  const handleExport = () => {
    void exportLegacyDashboard(clients);
  };

  return (
    <Button
      onClick={handleExport}
      disabled={isExporting || clients.length === 0}
      type="button"
      size="sm"
      variant="outline"
      className="!py-[9px] !px-2 text-foreground/70 hover:text-foreground border-input hover:bg-accent"
      data-testid="legacy-dashboard-export-excel-button"
      title={t('export.button')}
    >
      {isExporting ? (
        <FontAwesomeIcon icon={faSpinnerThird} className="animate-spin" />
      ) : (
        <FontAwesomeIcon icon={faFileArrowDown} />
      )}
    </Button>
  );
};
